import AntdEmpty from 'antd/lib/empty';
import React     from 'react';

type EmptyProps = {
	description?: React.ReactNode;
	style?: React.CSSProperties;
	simple?: boolean;
	children?: React.ReactNode;
}

const Empty = (props: EmptyProps) => {
	return (
		<AntdEmpty
			description={props.description}
			style={props.style}
			image={props.simple ? AntdEmpty.PRESENTED_IMAGE_SIMPLE : undefined}
		>
			{props.children}
		</AntdEmpty>
	);
};

export default Empty;
